import PropTypes from 'prop-types'
import React from 'react'

import { InputAutocomplete } from 'twyne-new.ui'
import './index.scss' // override css

export default function AutocompleteInput({ value, onChange, trigger, options, spacer, maxOptions, ...props }) {
  return <InputAutocomplete
    {...props}
    Component="input"
    value={value}
    onChange={onChange}
    trigger={trigger}
    options={options}
    spacer={spacer}
    maxOptions={maxOptions}
  />
}

AutocompleteInput.propTypes = {
  trigger: PropTypes.array,
  spacer: PropTypes.string,
  options: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  maxOptions: PropTypes.number,
}

AutocompleteInput.defaultProps = {
  trigger: ["{"],
  options: { "{": ["keyword1", "keyword2"] },
  spacer: '}',
  maxOptions: 6,
}
